import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const isCustomerAdmin = ( userRoles ) => userRoles && _.indexOf( userRoles, 'ROLE_CUSTOMER_ADMIN' ) !== -1;
